// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  ReviewQuestion,
  REVIEW_RESULTS
} from '../models';

/**
 * `QuestionResultComponent` implements a view to show the result of a question.
 */
@Component({
  selector: 'she-question-result',
  template: `<span class="she-status she-status-{{question?.result}}"></span>`
})
export class QuestionResultComponent {
  /**
   * Current question.
   */
  @Input() question: ReviewQuestion;

  /**
   * Creates a new `QuestionResultComponent` instance.
   */
  constructor() {}

  /**
   * Returns the result of current question.
   * @return question result
   */
  public getResult(): string {
    return this.question ? REVIEW_RESULTS[this.question.result] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/question-result.component.ts